import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { PencilIconComponent } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {
  ColorScheme,
  PencilBottomSheetContainerComponent,
} from '../../../../../../standalones/components/pencil-bottom-sheet-container/pencil-bottom-sheet-container.component';
import { UiModule } from '../../../../../../ui/ui.module';

@Component({
  selector: 'app-rename-title-bottom-sheet',
  standalone: true,
  imports: [
    CommonModule,
    MatBottomSheetModule,
    PencilButtonComponent,
    PencilIconComponent,
    TranslateModule,
    PencilBottomSheetContainerComponent,
    UiModule,
  ],
  templateUrl: './rename-title-bottom-sheet.component.html',
  styleUrls: ['./rename-title-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenameTitleBottomSheetComponent implements AfterViewInit {
  @ViewChild('input') input?: ElementRef<HTMLInputElement>;

  public ColorScheme = ColorScheme;
  public PencilButtonThemeEnum = PencilButtonThemeEnum;

  isTitleValid$ = new BehaviorSubject<boolean>(true);
  titleValidationErrMsg$ = new BehaviorSubject<string>('');
  maxAllowedCharacters = 0;

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<RenameTitleBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { title: string; value: string; colorScheme: ColorScheme; maxLength: number },
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
  ) {
    this.maxAllowedCharacters = this.data.maxLength;
  }

  ngAfterViewInit(): void {
    this.input?.nativeElement.focus();
    this.input?.nativeElement.select();
    this.cdRef.detectChanges();
  }

  handleConfirm(): void {
    this._bottomSheetRef.dismiss({
      returnToPreviousBottomSheet: true,
      output: this.input?.nativeElement.value,
    });
  }

  handleCancel(): void {
    this._bottomSheetRef.dismiss({
      returnToPreviousBottomSheet: false,
      output: null,
    });
  }

  handleBackClick(): void {
    this._bottomSheetRef.dismiss({
      returnToPreviousBottomSheet: true,
      output: null,
    });
  }

  validateTitle(): void {
    const title = this.input?.nativeElement.value ?? '';

    if (title.trim().length === 0) {
      this.isTitleValid$.next(false);
      this.titleValidationErrMsg$.next(this.translate.instant('Title cannot be empty'));
      return;
    }

    if (title.length > this.maxAllowedCharacters) {
      this.isTitleValid$.next(false);
      this.titleValidationErrMsg$.next(
        this.translate.instant('Titles must be {{maxAllowedCharacters}} characters max', {
          maxAllowedCharacters: this.maxAllowedCharacters,
        }),
      );
      return;
    }

    this.resetValidationState();
  }

  resetValidationState(): void {
    this.isTitleValid$.next(true);
    this.titleValidationErrMsg$.next('');
  }
}
